// extracted by mini-css-extract-plugin
module.exports = {"brand":"Brand_brand__yOdW7","sticky":"Brand_sticky__DOlQ4","logoDiv":"Brand_logoDiv__d7kDg","logo":"Brand_logo__0YLIC"};